import { Link } from "react-router-dom";
import { movies, newsArticles, tvshows } from "@/lib/content";

const ENTRIES = [
  {
    to: "/movies",
    icon: "ri-film-line",
    title: "电影",
    description: "精选最新动作、科幻、爱情、悬疑等类型电影，快速查看剧情与演职人员。",
    count: movies.length,
    unit: "部电影",
  },
  {
    to: "/tvshows",
    icon: "ri-tv-2-line",
    title: "电视剧",
    description: "热门剧集全集介绍，覆盖悬疑、古装、都市、科幻等题材，追剧更轻松。",
    count: tvshows.length,
    unit: "部剧集",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    description: "行业动态、票房快报与深度专访，第一时间了解影视圈正在发生的事。",
    count: newsArticles.length,
    unit: "条资讯",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 py-12 md:px-6 lg:px-10 lg:py-16">
      <div className="mb-6">
        <span className="mb-2 inline-flex items-center gap-2 text-xs font-label uppercase tracking-widest text-primary-400">
          <span className="h-1 w-6 rounded-full bg-primary-500" />
          快速入口
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          三大板块，快速找到你想看的
        </h2>
      </div>

      <div className="no-scrollbar flex gap-4 overflow-x-auto pb-2 md:grid md:grid-cols-3 md:gap-5 md:overflow-visible md:pb-0">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex w-72 shrink-0 flex-col rounded-lg border border-background-200/70 bg-background-100/60 p-5 transition-colors duration-300 hover:border-primary-500/60 md:w-auto md:p-6"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500/15 text-2xl text-primary-400">
              <i className={entry.icon} />
            </span>
            <h3 className="mt-4 flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              {entry.title}
              <i className="ri-arrow-right-up-line text-sm text-primary-400 transition-transform duration-300 group-hover:translate-x-1" />
            </h3>
            <p className="mt-2 flex-1 text-sm leading-7 text-foreground-600">{entry.description}</p>
            <span className="mt-4 text-xs font-label text-accent-400">
              {entry.count} {entry.unit}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}